export const domainApi = import.meta.env.VITE_API_DOMAIN;
export const nodeDomainApi = import.meta.env.VITE_NODE_API_DOMAIN;
